module.exports = __webpack_public_path__ + "mh.svg?003ce07ce88ab55b92c05992fcea3402";